import styled from 'styled-components';

export const MapChartContainer = styled.div`
  flex: 1;
  max-width: 624px;

  & > div {
    margin-left: 80px;

    width: 468px;
    height: 458px;
  }

  @media (max-width: 768px) {
    width: 100%;

    & > div {
      margin: 0 auto;
      width: 80vw;
    }
  }

  @media (min-width: 1280px) and (max-width: 1920px) {
    & > div {
      margin-left: auto;
      width: 100%;
      min-width: 348px;
    }
  }

  @media (min-width: 1920px) {
    & > div {
      margin-left: 80px;
      width: 468px;
    }
  }
`;
